<div class="m-home-page">
    <div class="orderfailed-mockup">
      <img src="../../../assets/images/nointernet.png" alt="img">
    </div>
    <div class="text-orderfaild">
      <h4>No Internet Connection</h4>
      <p>Please check your internet
        connectivity</p>
      <!-- <a href="javascript:void(0);">Try Again</a> -->
    </div>
</div>